import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { ExpenseRepository } from "../domain/ExpenseRepository";
import { Expense } from "../domain/Expense";

export function createApiExpenseRepository(): ExpenseRepository {
  return new ApiExpenseRepository();
}

export class ApiExpenseRepository
  extends APIRepository
  implements ExpenseRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getExpenseByObjectIdAndType(companyId: string, uid:string, type:string): Promise<Expense> {
    console.log("(ApiExpenseRepository) call getExpenseByChildIdAndType:" + companyId + ", uid:" + uid + ", type:" + type );
    try {
        return this.doGet<Expense>("/api/expenses/company/" + companyId.toString() + "/uid/" + uid.toString() + "/type/" + type.toString()  );

    } catch (error) {
      console.log("(ApiExpenseRepository) getExpenseByChildIdAndType error:" + error);
      return Promise.reject();
    }
  }
}
